export default "__VITE_ASSET__CxFT5zGr__"